import type { GetCourseDraftById200LocalizedSectionsItem } from './getCourseDraftById200LocalizedSectionsItem';

/**
 * 언어별 섹션 정보 매핑
 * @nullable
 */
export type GetCourseDraftById200LocalizedSections = {[key: string]: GetCourseDraftById200LocalizedSectionsItem[]} | null;
